module.exports = __webpack_public_path__ + "img/article_5_5.002c0a35.png";